// Component Name: ExperienceDetails
// Description: Shows experience paragraph and doctor image side-by-side with clean layout.
import React from 'react';
import styles from './ExperienceDetails.module.css'; // CSS Modules
function ExperienceDetails() {
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

  return (
    <div className={styles.experienceDetails}>
      <div
        className="experience-details"
        style={{ width: "70%", margin: "0 auto", backgroundColor: "#B4807D" }}>
        <div className="experience-points" style={{width:"600px", lineHeight:"26px"}}>
            <h3 style={{fontSize:"26px", marginBottom:"2px",marginTop:"4px"}}>Philosophy of Care</h3>
          <p>
            My approach to gastroenterology is built on three pillars: Evidence-based Medicine,
             Compassionate Care, and Patient Education. Every patient deserves to understand their
             condition completely and participate actively in their healing journey. 
             At Krisara Gastro and Liver Clinic, we don't just treat diseases—we restore hope,
              comfort, and quality of life.
          </p>
        </div>
        <div className="experience-doctor">
          <img
            src="https://i.ibb.co/5WT8b5SL/doc-sagar-1.png"
            alt="Dr Shruti Sagar - Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"/>
        </div>
      </div>
    </div>
  );
}
export default ExperienceDetails;